import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './shop-users.loaders';
import { converters } from './shop-users.converters';
import { ShopUsersFilters } from './shop-users.types';

export const shopUsersKeys = queryKeyFactory('shop-users');

export const useShopUsers = (filters: Partial<ShopUsersFilters> = {}) => {
  return useQuery({
    queryKey: shopUsersKeys.list(filters),
    queryFn: () => loaders.getShopUsers({ filters }),
    select: converters.getShopUsers,
  });
};

export const useShopUser = (shopUserId: string) => {
  return useQuery({
    queryKey: shopUsersKeys.detail(shopUserId),
    queryFn: () => loaders.getShopUser({ shopUserId }),
    select: converters.getShopUser,
    enabled: !!shopUserId,
  });
};
